import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "waybills-header-additional" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 7h6v6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m22 7-8.5 8.5-5-5L2 17" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 3.128a4 4 0 0 1 0 7.744" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 22V12" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "3.29 7 12 12 20.71 7" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m7.5 4.27 9 5.15" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_statistic = _resolveComponent("bs-statistic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_bs_statistic, {
            label: "Всего",
            value: _ctx.total
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_bs_statistic, {
            label: "Экипаж",
            value: _ctx.crew
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_bs_statistic, {
            label: "Грузовые",
            value: _ctx.cargo,
            color: "orange"
          }, {
            icon: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["value"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}